import { checkoutShippingCarrierServiceStyles as styles } from "@tggstore/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { css } from "styled-components";

styles.carrierGridItem = {
    ...styles.carrierGridItem,
    css: css`
        flex-direction: column;
    `,
};

styles.serviceGridItem = {
    ...styles.serviceGridItem,
    css: css`
        flex-direction: column;
    `,
};
